import React from 'react';
const Loader = ({className,zoom}) => {
    return <div className={`loader ${className}`} style={{zoom}}></div>
};

export default Loader;